import React, { ReactElement, useEffect, useRef, useState } from "react";

import { Divider, ProgressBar } from "components";

export type StickyFooterProps = {
  absolute?: boolean;
  children: ReactElement | ReactElement[];
  size?: string;
  className?: string;
  progressBarPercent?: number;
};

export const StickyFooter = ({
  absolute = false, // used to position the footer in a drawer, for example
  children,
  size = "tiniest",
  className = "",
  progressBarPercent,
}: StickyFooterProps) => {
  const footerRef = useRef<HTMLInputElement>(null);
  const [footerHeight, setFooterHeight] = useState<number>(0);

  // we want this useEffect to run on every render, as ref changes do not trigger a render update themselves
  // eslint-disable-next-line
  useEffect(() => {
    const newHeight = footerRef?.current?.offsetHeight || 0;
    setFooterHeight(newHeight);
  });

  return (
    <>
      <div style={{ minHeight: `${footerHeight}px` }} /> {/* add a spacer for sticky footer, otherwise we get overlaps */}
      <div className={`sticky-footer${absolute ? " absolute" : ""}${className ? ` ${className}` : ""}`} ref={footerRef}>
        {progressBarPercent !== undefined && (
          <div className="progress-bar" style={{ lineHeight: 0 }}>
            <ProgressBar
              percent={progressBarPercent * 100}
              showInfo={false}
              strokeLinecap="square"
              strokeColor="#065c45"
              strokeWidth={4}
              style={{ lineHeight: 0 }}
              className="footprinting-progress-bar-animation"
            />
          </div>
        )}
        <Divider />

        <section className={`container ${size}`}>{children}</section>
      </div>
    </>
  );
};
